import React, { useState } from 'react';
import slideDeckService, { DeckType } from '../services/slideDeckService';
import { PageHeader } from '../components/ui';
import { routeById } from '../navigation/routes';

const DECK_TYPES: { value: DeckType; label: string }[] = [
  { value: 'sales', label: 'Sales-Deck' },
  { value: 'qbr', label: 'QBR / Reporting' },
  { value: 'case_study', label: 'Case Study' },
  { value: 'onboarding', label: 'Onboarding / Training' },
];

const SlideDeckPage: React.FC = () => {
  const [source, setSource] = useState('');
  const [title, setTitle] = useState('');
  const [deckType, setDeckType] = useState<DeckType>('sales');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const handleGenerate = async () => {
    if (!source.trim()) {
      setError('Bitte ein Quelldokument einfügen');
      return;
    }
    try {
      setLoading(true);
      setError('');
      setInfo('');
      const { blob, filename } = await slideDeckService.generate({
        source,
        title: title || undefined,
        deckType,
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setInfo(`Deck „${filename}" erzeugt und heruntergeladen.`);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Fehler beim Erzeugen des Decks');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <PageHeader title="Präsentationen (Slide-Deck)" subtitle={routeById('slide-deck')?.description} />
      <p style={{ color: 'var(--sec-fg-muted)', marginBottom: '24px' }}>
        Erzeugt aus einem Quelldokument ein fertiges <strong>.pptx</strong> (powered by Skill{' '}
        <em>slide-deck-builder</em>): KI strukturiert die Slides, die Datei wird direkt zum Download
        gerendert.
      </p>

      {error && <div className="alert alert-error">{error}</div>}
      {info && <div className="alert alert-success">{info}</div>}

      <div className="form-section" style={{ borderLeft: '4px solid var(--sec-accent)' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
          <div className="form-group" style={{ flex: '1 1 280px' }}>
            <label className="form-label">Titel (optional)</label>
            <input className="form-input" value={title} onChange={(e) => setTitle(e.target.value)} />
          </div>
          <div className="form-group" style={{ flex: '1 1 220px' }}>
            <label className="form-label">Deck-Typ</label>
            <select className="form-input" value={deckType} onChange={(e) => setDeckType(e.target.value as DeckType)}>
              {DECK_TYPES.map((d) => (
                <option key={d.value} value={d.value}>
                  {d.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Quelldokument</label>
          <textarea
            className="form-textarea"
            rows={12}
            value={source}
            onChange={(e) => setSource(e.target.value)}
            placeholder="Text, Notizen, Pitch oder Bericht hier einfügen — die KI macht daraus strukturierte Slides."
          />
        </div>
        <button className="btn btn-success" onClick={handleGenerate} disabled={loading}>
          {loading ? 'Erzeuge Deck…' : 'Deck erzeugen (.pptx)'}
        </button>
      </div>
    </div>
  );
};

export default SlideDeckPage;
